import React, {useContext, useEffect, useState} from "react";
import toolboxLogo from "../assets/img/Audience-Designer-Toolbox_White2.svg"
import semcastingLogo from "../assets/img/Semcasting_Archer_RGB_White.png";
import "./SplashLandingToolboxPage.css"

import {Field, Form, FormElement} from "@progress/kendo-react-form";
import {Input} from "@progress/kendo-react-inputs";
import {Button} from "@progress/kendo-react-buttons";
import ReCAPTCHA from "react-google-recaptcha";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import LandingPageFooter from "./LandingPageFooter";
import {
    extractAuthCookie,
    semcastAxios,
    setAuthCookieToStorage,
    setDataToStorage, setUserDataToStorage, showErrorToastMessage,
    showSuccessToastMessage
} from "../../Utils/Common";
import {
    AUTHORIZE_API,
    LOGIN_ATTEMPT_API,
    SUCCESS_STATUS,
    USER,
    USER_INFO_API,
    USERS_PERMISSIONS_API
} from "../../api/constants";
import {useFormik} from "formik";
import "./LoginPage.css";
import {Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import stopwatch from "../../Admin/Components/Segmentation/temporaryresources/images/stopwatch.png";
import googleIcon from "../../Admin/Components/Segmentation/temporaryresources/images/google-icon.png";
import {loadFounderAccountsData} from "../../actions/AccountActions";
import {loadUserPermissions, loadUserProfile} from "../../actions/UserActions";
import {UserContext} from "../../contexts/UserContext";
import {hasAtLeastOneInAnyGroup, PERMISSIONS_NEEDED_TO_VIEW_PERMISSIONS_PAGE} from "../../helpers/UsersHelpers";
import {buildSsoLoginUrl, buildSsoTarget} from "../../Utils/SsoLoginUrl";

const SplashLandingToolboxPage = () => {
    const searchParams = new URLSearchParams(document.location.search);
    const {user, setUser}= useContext(UserContext);
    const [fetchedUserInfo,setFetchedUserInfo] = useState({});
    const timeout = searchParams.get('timeout');
    const ssoError = searchParams.get('ssoError');
    const forcedLogoutReason = localStorage.getItem("forcedLogoutReason");
    // Remove url timeout param after identified..
    window.history.replaceState(null, '', window.location.pathname);
    const [displayReCaptcha, setDisplayReCaptcha] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    // captcha vars
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [showTimedOut, setShowTimedOut] = useState(timeout ? true: false);
    const emailRegex = new RegExp(/\S+@\S+\.\S+/);
    const emailValidator = value => !value ? "Email is required." : emailRegex.test(value) ? "" : "Email is not in a valid format.";
    const [showPassword, setShowPassword] = useState(false);
    const [disableResetPassButton, setDisableResetPassButton] = useState(false);

    const loginFormik= useFormik ({
        initialValues: {
            email: "",
            password: ""
        }
    })
    const showPass = () => setShowPassword(!showPassword);

    // Controlling the disabling of the submit button in the form submit is fine but may not be quick enough.
    // Here it is set in a click handler (before the form submit - then the form submit handler will take over
    const handleForgotPasswordClick = (e) => {
        setDisableResetPassButton(true);
    };

    const handleForgotPassword = async (e) => {
        // e.preventDefault();
        setDisableResetPassButton(true);

        await semcastAxios.post("/v2/attributor/password-reset",
            {
                email: loginFormik.values.email,
            },
            {withCredentials: true})
            .then(function (response) {
                // console.log(response);
                if (response.data.status === "success") {
                    showSuccessToastMessage(
                        `An email has been sent to ${loginFormik.values.email} with further instructions. If you can't find it be sure and check your spam folder.`
                    );
                }
                setDisableResetPassButton(false);
            })
            .catch(function (error) {
                showErrorToastMessage(`An email could not be sent to ${loginFormik.values.email}. Please try again or contact support@semcasting.com for further assistance.`);
                setDisableResetPassButton(false);
            });
    };

    const handlePasswordResetWindowChange = () => {
        if(showResetPassword) {
            setShowResetPassword(false);
        } else {
            setShowResetPassword(true);
        }
    };

    const handleSsoLogin = (provider) => {
        const target = buildSsoTarget(window.location.pathname, window.location.search);
        const apiServer = window?.env?.REACT_APP_API_SERVER || window.location.origin;
        window.location.href = buildSsoLoginUrl({apiServer, provider, target});
    };

    // function setCookie(cname, cvalue, mins) {
    //     // console.log("inSetCookie");
    //     const d = new Date();
    //     d.setTime(d.getTime() + (mins*60*1000));
    //     let expires = "expires="+ d.toUTCString();
    //     document.cookie = cname + "=" + cvalue + ";" + "secure;" + expires + ";path=/";
    // };
    function setReCaptchaTrigger(cname, cvalue) {
        console.log("setReCaptchaTrigger");
        sessionStorage.setItem(cname, cvalue);
    }
    // function getCookie(cname) {
    //     let name = cname + "=";
    //     let decodedCookie = decodeURIComponent(document.cookie);
    //     let ca = decodedCookie.split(';');
    //     for(let i = 0; i <ca.length; i++) {
    //         let c = ca[i];
    //         while (c.charAt(0) === ' ') {
    //             c = c.substring(1);
    //         }
    //         if (c.indexOf(name) === 0) {
    //             return c.substring(name.length, c.length);
    //         }
    //     }
    //     return 0;
    // };
    function getReCaptchaTrigger(cname) {
        if(sessionStorage.getItem(cname)){
            return sessionStorage.getItem(cname)
        }else{
            return 0;
        }
    }
    // clickHandler generates and returns reCaptcha token
    const clickHandler = async () => {
        let captchaToken = "";

        // Uncomment the following for captcha
        if (executeRecaptcha) {
            await executeRecaptcha('SignInADSV2')
                .then(async (result) => {
                    captchaToken = result;
                    return captchaToken;
                })
        }
        return captchaToken;
    };

    // public recaptcha v2 checkbox key
    const SITE_KEY = "6LeSTW8eAAAAAP2cJ8RZfEnPR2GklW3_a-tQn9pt";
    const reCaptchaRef = React.createRef();

    // run when captcha solved successfully
    const handleChange = (token) => {
        setDisableSubmit(false);
        // setCookie("attempts", 0, 10);
        let attemptRes = semcastAxios.post(LOGIN_ATTEMPT_API, {data:0},{withCredentials: true});
        // setReCaptchaTrigger("attempts", 0);
    };

    const handleSubmit = async (e) => {
        let userProfile;
        let attemptLimit;
        if (loginFormik.values.email.length && loginFormik.values.password.length) {
            let attemptRes = await semcastAxios.post(LOGIN_ATTEMPT_API, {},{withCredentials: true}).then((response) => {
                if (response.data) {
                    attemptLimit = parseInt(response.data.value)
                }
            });
            // Check value of attempts cookie - if it has been edited to not a number, set to 4, triggering reCaptcha. Else, increment value of attempts cookie.

            // Uncomment the following two lines for captcha
            // if(!parseInt(getCookie("attempts")) && parseInt(getCookie("attempts")) !== 0) setCookie("attempts", 4, 10);
            // else setCookie("attempts", parseInt(getCookie("attempts")) + 1, 10);
            // if(!parseInt(getReCaptchaTrigger("attempts")) && parseInt(getReCaptchaTrigger("attempts")) !== 0) setReCaptchaTrigger("attempts", 4);
            // else setReCaptchaTrigger("attempts", parseInt(getReCaptchaTrigger("attempts")) + 1);

            // clickhandler generates recaptcha v3 code to send to the backend
            await clickHandler()
                .then(async (captchaToken) => {
                    // console.log("Value of email and password and token", loginFormik.values.email, loginFormik.values.password, captchaToken);
                    // if "attempts" cookie > 3, don't execute sign-in. Disable submit button and render captcha v2 checkbox
                    // if (getCookie("attempts") > 3) {
                    if (attemptLimit > 3) {
                        setDisableSubmit(true);
                        setDisplayReCaptcha(true)
                    } else {
                        setDisplayReCaptcha(false)
                        try {
                            let response = await semcastAxios.post(AUTHORIZE_API, {
                                email: loginFormik.values.email,
                                password: loginFormik.values.password,
                                c: captchaToken,
                            });
                            if (response?.data?.status === SUCCESS_STATUS) {
                                // We need to check if this is a valid toolbox user.
                                try {
                                    userProfile = await loadUserProfile();
                                    //Validate User Is Toolbox User
                                    if (userProfile.is_adsone_user === false) {
                                        showSuccessToastMessage('Success! Logging in...', 3);
                                    }else{
                                        showErrorToastMessage("Toolbox Validation Failed. ",  10);
                                        return;
                                    }
                                } catch (error) {
                                    showErrorToastMessage("Toolbox Validation Failed. "+error, 10);
                                }

                                sessionStorage.setItem('user', JSON.stringify(userProfile));
                                // set captcha badge to "hidden", so badge will not appear on other pages
                                let badge = document.getElementsByClassName("grecaptcha-badge").item(0);
                                badge.style.visibility = "hidden";
                                setDataToStorage(true, response.data.id);
                                sessionStorage.setItem("isToolboxLogged", true);
                                setAuthCookieToStorage(extractAuthCookie());
                                localStorage.removeItem("dismissedSystemNotifs");
                                // history.push("/segmentation-dashboard");
                                window.location.href ="/segmentation-dashboard"
                                //await loadUserInfo();
                            }
                        } catch (error) {
                            if (error.response) {
                                if(error.response.data.data){
                                    showErrorToastMessage(error.response.data.data, 10);
                                }else{
                                    showErrorToastMessage(" Login Failed: Please contact adssupport@semcasting.com", 10);
                                }
                            }else{
                                showErrorToastMessage(error + " Login Failed: Please contact adssupport@semcasting.com", 10);
                            }
                        } finally {

                        }
                    }
                })
        } else {
            // Renders error message for failed login
            showErrorToastMessage("Login Failed: Incorrect email or password.", 5);
        }
    };

    useEffect(() => {
        if (document.getElementById("emailSignIn")) {
            document.getElementById("emailSignIn").focus();
        }
    }, [document.getElementById("emailSignIn")]);

    useEffect(() => {
        if (forcedLogoutReason) {
            showErrorToastMessage(forcedLogoutReason, 8);
            localStorage.removeItem("forcedLogoutReason");
        }
    }, [forcedLogoutReason]);

    useEffect(() => {
        if (ssoError) {
            showErrorToastMessage("Login Failed: Incorrect email or password.", 5);
        }
    }, [ssoError]);

    useEffect(() => {

        document.body.style.zoom = "100%";

        // Make recaptcha badge visible on this page only
        let badge = document.getElementsByClassName("grecaptcha-badge").item(0);
        if(badge) {
            badge.style.visibility = "visible";
            badge.style.bottom = '70px';
        }

        // Check value of attempts cookie - if it is not a number, set attempts to 4, triggering reCaptcha. If it does not exist, set to 0.

        // Uncomment following lines for captcha
        // if(!parseInt(getCookie("attempts")) && parseInt(getCookie("attempts")) !== 0) setCookie("attempts", 4, 10);
        // else if(!parseInt(getCookie("attempts"))) setCookie("attempts", 0, 10);
        // if(!parseInt(getReCaptchaTrigger("attempts")) && parseInt(getReCaptchaTrigger("attempts")) !== 0) setReCaptchaTrigger("attempts", 4);
        // else if(!parseInt(getReCaptchaTrigger("attempts"))) setReCaptchaTrigger("attempts", 0);

        if (!executeRecaptcha) {
            return;
        }
    }, [executeRecaptcha, disableSubmit, handleChange]);


    return (
        <div className={"splash-page-outer-container"}>
        <div className={"splash-toolbox-page-background"}>
            <div className={"splash-page-main-text-div"}>
                {/*<div >*/}
                {/*    <img src={semcastingLogo} className={"semcasting-logo"}/>*/}
                {/*</div>*/}
                <div className={"login-dialog-container"} >
                    <div className={"section-card landing-page-login-card box-shadow-standard section-card-outer-margins"}>
                        <div className={"landing-page-login-container"}>
                            <div className={"landing-page-logo-wrapper"}>

                                <img src={toolboxLogo} className={"landing-page-logo"}/>
                                <a href="https://semcasting.com/" target="_blank" rel="noreferrer"
                                   className={"splash-page-semcasting-link"}>By Semcasting</a>
                            </div>

                            {showResetPassword === true ? (
                                <Form onSubmit={handleForgotPassword} onSubmitClick={handleForgotPasswordClick} className={"resetPwForm"} render={formRenderProps => <FormElement className={"reset-password-form"} style={{
                                    maxWidth: 650
                                }}>

                                    <div className={"signInDialogResetPwDiv signInDialogFormFieldsDiv"}>

                                        <Field
                                            name={'email'}
                                            className={"text-field"}
                                            id={'emailPwReset'}
                                            type={'email'}
                                            component={Input}
                                            label={'Email'}
                                            onChange={(e) => {
                                                loginFormik.values.email = e.target.value;
                                            }}
                                        />

                                        <a id="myLink" className="forgot-password-link" href="#" onClick={handlePasswordResetWindowChange}>Remembered Password?</a>

                                    </div>

                                    <div className="login-button-container">

                                        <Button className={"splash-page-dialog-button landing-page-button"} type={'submit'} disabled={!formRenderProps.allowSubmit || !loginFormik.values.email.length || emailValidator(loginFormik.values.email) || disableResetPassButton} >
                                            Send Password Reset Email
                                        </Button>

                                    </div>
                                </FormElement>} />
                            ) : (
                                <Form onSubmit={handleSubmit} render={formRenderProps => <FormElement className={"login-form"} style={{
                                    maxWidth: 650
                                }}>

                                    <div className={"login-fields-container"}>

                                        <Field
                                            name={'email'}
                                            className={"text-field"}
                                            id={'emailSignIn'}
                                            type={'email'}
                                            component={Input}
                                            label={'Email'}
                                            onChange={(e) => {
                                                loginFormik.values.email = e.target.value;
                                            }}
                                        />

                                        <div className={"password-field-wrapper"}>
                                            <Field
                                                name={'password'}
                                                autoComplete="off"
                                                className={"text-field login-password-field"}
                                                component={Input}
                                                label={'Password'}
                                                type={showPassword ? "text" : "password"}
                                                onChange={(e) => {
                                                    loginFormik.values.password = e.target.value;
                                                }}
                                            />
                                            <Button type={"button"} className="toggle-view-password" icon="eye"
                                                    onClick={showPass} disabled={!loginFormik.values.password && loginFormik.values.password.length}></Button>
                                        </div>
                                        <a id="myLink" className="forgot-password-link" href="#" onClick={handlePasswordResetWindowChange}>Forgot Password?</a>

                                    </div>

                                    {/*Div containing captcha*/}
                                    <div className="captcha-container">
                                        {/*{getCookie("attempts") > 3 && (*/}
                                        {displayReCaptcha && (
                                            <ReCAPTCHA
                                                className={"g-recaptcha"}
                                                ref={reCaptchaRef}
                                                sitekey={SITE_KEY}
                                                onChange={handleChange}
                                            />
                                        )}
                                    </div>

                                    <div className="k-form-buttons login-button-container">

                                        {/*Captcha disabled*/}
                                        {/*<Button themeColor={'primary'} className={"splash-page-dialog-button landing-page-button"} type={'submit'}*/}
                                        {/*        disabled={!formRenderProps.allowSubmit || !email.length || !password.length || emailValidator(email)}>*/}
                                        {/*    Sign In*/}
                                        {/*</Button>*/}

                                        {/*Captcha enabled*/}
                                        <Button name="SignIn" themeColor={'primary'} className={"splash-toolbox-page-dialog-button landing-page-button"} type={'submit'}
                                                disabled={!formRenderProps.allowSubmit || disableSubmit || !loginFormik.values.email.length || loginFormik.values.password && !loginFormik.values.password.length|| emailValidator(loginFormik.values.email)}>
                                            Sign In
                                        </Button>
                                    </div>

                                    <div className="sso-divider">
                                        <span>or</span>
                                    </div>
                                    <div className="sso-button-group">
                                        <Button type="button" className="sso-button google" onClick={() => handleSsoLogin('google')}>
                                            <span className="sso-label">
                                                <img src={googleIcon} alt="" className="sso-provider-icon"/>
                                                <span>Sign in with Google</span>
                                            </span>
                                        </Button>
                                        <Button type="button" className="sso-button microsoft" onClick={() => handleSsoLogin('microsoft')}>
                                            <span className="sso-label">
                                                <span className="sso-provider-icon microsoft-icon" aria-hidden="true">
                                                    <span className="microsoft-icon-square red"/>
                                                    <span className="microsoft-icon-square green"/>
                                                    <span className="microsoft-icon-square blue"/>
                                                    <span className="microsoft-icon-square yellow"/>
                                                </span>
                                                <span>Sign in with Microsoft</span>
                                            </span>
                                        </Button>
                                    </div>
                                </FormElement>} />)}
                        </div>
                    </div>
                    <a id="myLink" className="no-account-link" href="https://www.semcasting.com/ads">Don't have an account?</a>
                </div>
                <div className={"semcasting-logo-container"}>
                    <img src={semcastingLogo} style={{maxWidth: "100%"}}/>
                </div>
            </div>

        </div>
            {showTimedOut && (
                <Dialog
                    // title={"Your session has expired!"}
                    width={400}
                    height={212}
                    closeIcon={false}
                    className={"dialog-standard"}
                >
                    <div className={"activity-tracker-msg-div"}>
                        <img className={"activity-tracker-stopwatch"} src={stopwatch} alt=""/>
                        <div className={"field-label"}>
                            Your session has expired.
                        </div>
                    </div>

                    <DialogActionsBar layout={"center"}>
                        <Button
                            className={"button-standard button-submit"}
                            onClick={() => {
                                setShowTimedOut(false);
                            }}>
                            OK
                        </Button>
                    </DialogActionsBar>
                </Dialog>
                )}
            <LandingPageFooter />
        </div>
    )
}

export default SplashLandingToolboxPage;
